module.exports = __webpack_public_path__ + "static/media/ModifyBill.6117bcc3.png";